import { TacoRating } from '@appsumo/dorado-react';
import { Link } from '~/components/global';

export function DealRating({
  href,
  averageRating,
  reviewCount,
  className,
  target = '_self',
}: {
  href: string;
  averageRating?: number;
  reviewCount?: number;
  className?: string;
  target?: '_self' | '_blank';
}) {
  const showRating =
    !!averageRating && averageRating >= 0 && !!reviewCount && reviewCount > 0;
  return (
    <div
      className={`flex items-center 
       gap-3 ${className ? className : ''}`}
    >
      {showRating && (
        <TacoRating
          href={href}
          averageRating={averageRating}
          reviewCount={reviewCount.toString()}
          className="z-2 h-2 sm:h-3"
          linkClassName="z-2 whitespace-nowrap md:font-medium md:text-sm"
        />
      )}
      {reviewCount === 0 && (
        <div className="text-xs">
          No reviews yet,{' '}
          <Link
            href={href}
            className="relative z-2 text-blue-600 hover:underline"
            target={target}
          >
            be the first!
          </Link>
        </div>
      )}
    </div>
  );
}
